import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { deleteDoc, doc } from 'firebase/firestore';
import Swal from 'sweetalert2';
import { DB } from '~/services/firebase';

import Dashboard from '~/layouts/Dashboard';
import { useToast } from '~/hooks/toast';
import { useDeliverymen } from '~/hooks/deliverymens';

const Delvierymen: React.FC = () => {
  const { loadDeliverymens, deliverymens } = useDeliverymen();
  const { addToast } = useToast();
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('Todos');
  const [showFilter, setShowFilter] = useState(false);

  useEffect(() => {
    loadDeliverymens();
  }, [loadDeliverymens]);

  const filteredCategories = useMemo(() => {
    const filtered = deliverymens?.filter(category => {
      let result = true;

      if (status === 'Ativo') {
        result =
          category.name
            .toLocaleLowerCase()
            .includes(search.toLocaleLowerCase()) && category.status === true;
      } else if (status === 'Inativo') {
        result =
          category.name
            .toLocaleLowerCase()
            .includes(search.toLocaleLowerCase()) && category.status === false;
      } else {
        result = category.name
          .toLocaleLowerCase()
          .includes(search.toLocaleLowerCase());
      }

      return result;
    });
    return filtered || [];
  }, [search, deliverymens, status]);

  const handleConfirmRemove = useCallback(
    async (id: string) => {
      const { isConfirmed } = await Swal.fire({
        title: 'Atenção!',
        text: 'Confirme a exclusão do entregador?',
        icon: 'warning',
        confirmButtonText: 'Sim',
        showCancelButton: true,
        cancelButtonText: 'Não',
      });

      if (isConfirmed) {
        await deleteDoc(doc(DB, 'deliverymen', id));

        loadDeliverymens();

        addToast({
          type: 'success',
          description: 'O entregador foi removido com sucesso.',
        });
      }
    },
    [addToast, loadDeliverymens],
  );

  return (
    <Dashboard containerMessage="col-xl-8 offset-xl-2">
      <div className="col-xl-8 offset-xl-2">
        <div className="nk-block-head nk-block-head-sm">
          <div className="nk-block-between">
            <div className="nk-block-head-content">
              <h3 className="nk-block-title page-title">Entregadores</h3>
            </div>
            <div className="nk-block-head-content">
              <div className="toggle-wrap nk-block-tools-toggle">
                <button
                  type="button"
                  className={`btn btn-icon btn-trigger toggle-expand mr-n1 ${
                    showFilter && 'active'
                  }`}
                  data-target="pageMenu"
                  onClick={() => setShowFilter(current => !current)}
                >
                  <em className="icon ni ni-more-v" />
                </button>
                <div
                  className={`toggle-expand-content ${
                    showFilter && 'expanded'
                  }`}
                  data-content="pageMenu"
                >
                  <ul className="nk-block-tools g-3">
                    <li>
                      <div className="form-control-wrap">
                        <div className="form-icon form-icon-right">
                          <em className="icon ni ni-search" />
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          id="default-04"
                          placeholder="Buscar por nome"
                          onChange={event => {
                            setSearch(event.target.value);
                          }}
                        />
                      </div>
                    </li>
                    <li>
                      <div className="drodown">
                        <Link
                          to="#status"
                          className="dropdown-toggle dropdown-indicator btn btn-outline-light btn-white"
                          data-toggle="dropdown"
                        >
                          {status}
                        </Link>
                        <div className="dropdown-menu dropdown-menu-right">
                          <ul className="link-list-opt no-bdr">
                            <li>
                              <Link
                                to="#status"
                                onClick={() => setStatus('Todos')}
                              >
                                <span>Todos</span>
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="#active"
                                onClick={() => setStatus('Ativo')}
                              >
                                <span>Ativo</span>
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="#inactive"
                                onClick={() => setStatus('Inativo')}
                              >
                                <span>Inativo</span>
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    <li className="nk-block-tools-opt">
                      <Link
                        to="/deliverymen/create"
                        data-target="addProduct"
                        className="toggle btn btn-icon btn-primary d-md-none"
                      >
                        <em className="icon ni ni-plus" />
                      </Link>
                      <Link
                        to="/deliverymen/create"
                        data-target="addProduct"
                        className="toggle btn btn-primary d-none d-md-inline-flex"
                      >
                        <em className="icon ni ni-plus" />
                        <span>Cadastrar</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="nk-block">
          <div className="card card-bordered">
            <div className="card-inner-group">
              <div className="card-inner p-0">
                <div className="nk-tb-list">
                  <div className="nk-tb-item nk-tb-head">
                    <div className="nk-tb-col">
                      <span>Nome</span>
                    </div>
                    <div className="nk-tb-col">
                      <span>Contato</span>
                    </div>
                    <div className="nk-tb-col">
                      <span>Status</span>
                    </div>

                    <div className="nk-tb-col nk-tb-col-tools">
                      <ul className="nk-tb-actions gx-1 my-n1">
                        <li className="mr-n1" />
                      </ul>
                    </div>
                  </div>

                  {filteredCategories.map(category => (
                    <div className="nk-tb-item" key={category.uid}>
                      <div className="nk-tb-col">
                        <span className="tb-product">
                          <span className="title">{category.name}</span>
                        </span>
                      </div>

                      <div className="nk-tb-col">
                        <span className="title">{category.phone}</span>
                      </div>

                      <div className="nk-tb-col">
                        <div className="asterisk tb-asterisk">
                          <span
                            className={`text-${
                              category.status ? 'success' : 'danger'
                            } fs-12px`}
                          >
                            {category.status && <span>Ativo</span>}
                            {!category.status && <span>Inativo</span>}
                          </span>
                        </div>
                      </div>
                      <div className="nk-tb-col nk-tb-col-tools">
                        <ul className="nk-tb-actions gx-1 my-n1">
                          <li className="mr-n1">
                            <div className="dropdown">
                              <Link
                                to="#options"
                                className="dropdown-toggle btn btn-icon btn-trigger"
                                data-toggle="dropdown"
                              >
                                <em className="icon ni ni-more-h" />
                              </Link>
                              <div className="dropdown-menu dropdown-menu-right">
                                <ul className="link-list-opt no-bdr">
                                  <li>
                                    <Link
                                      to={`/deliverymen/edit/${category.uid}`}
                                    >
                                      <em className="icon ni ni-edit" />
                                      <span>Editar</span>
                                    </Link>
                                  </li>

                                  <li>
                                    <Link
                                      to="#remove"
                                      onClick={() => {
                                        handleConfirmRemove(category.uid);
                                      }}
                                    >
                                      <em className="icon ni ni-trash" />
                                      <span>Excluir</span>
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dashboard>
  );
};

export default Delvierymen;
